import React, { useState, useEffect } from 'react';
import './Billing.css';
import { useAuth } from '../../Security/AuthProvider';
import BillingSummary from './BillingSummary/BillingSummary';
import BillingDetails from './BillingDetails/BillingDetails';
import BillingHistory from './BillingHistory/BillingHistory';
import { useNotification } from '../../Utils/Commons/Notification/NotificationContext';

const Billing = () => {
  const { getCredentials } = useAuth();
  const [activeTab, setActiveTab] = useState('summary');
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { notifyError, notifySuccess } = useNotification();

  useEffect(() => {
    fetchCurrentMonthData();
  }, []);

  const fetchCurrentMonthData = async () => {
    try {
      setLoading(true);
      const credentials = getCredentials();
      
      const response = await fetch('/billing/current-month', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company_name: credentials.company_name,
          company_password: credentials.company_password,
        }),
      });

      const data = await response.json();
      
      if (data.success) {
        setCurrentMonthData(data.data);
        notifySuccess('Facture chargée avec succès');
      } else {
        // Aucune donnée pour ce mois
        setCurrentMonthData(null);
      }
    } catch (err) {
      console.error('Erreur lors de la récupération des données de facturation:', err);
      notifyError('Erreur lors du chargement des données de facturation');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleRdvStatusUpdate = () => {
    // Recharger les données quand un statut RDV change
    fetchCurrentMonthData();
  };

  if (loading) {
    return (
      <div className="billing-container">
        <div className="billing-loading">
          <div className="loading-spinner"></div>
          <p>Chargement des données de facturation...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="billing-container">
      <div className="billing-header">
        <h1>Gestion de la Facturation</h1>
        <p>Suivez et gérez vos rendez-vous pour la facturation</p>
      </div>

      <div className="billing-tabs">
        <button 
          className={`tab-button ${activeTab === 'summary' ? 'active' : ''}`}
          onClick={() => handleTabChange('summary')}
        >
          Résumé
        </button>
        <button 
          className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
          onClick={() => handleTabChange('details')}
        >
          Détails
        </button>
        <button 
          className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => handleTabChange('history')}
        >
          Historique
        </button>
      </div>

      <div className="billing-content">
        {!currentMonthData && (
          <button onClick={fetchCurrentMonthData}>Réessayer</button>
        )}

        {!loading && (
          <>
            {activeTab === 'summary' && (
              <BillingSummary 
                data={currentMonthData} 
                onRefresh={fetchCurrentMonthData}
              />
            )}
            
            {activeTab === 'details' && (
              <BillingDetails 
                data={currentMonthData} 
                onRdvStatusUpdate={handleRdvStatusUpdate}
              />
            )}
            
            {activeTab === 'history' && (
              <BillingHistory />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Billing; 